/**
 * Mash Gang — Selling Plan Selector
 *
 * Manages the One-time / Subscribe & Save toggle on product forms.
 * Works both on PDPs and inside the Quick Add modal (content loaded via AJAX).
 *
 * Subscribe button on collection cards sets window._mgSubscribeIntent = productId,
 * which causes the selector to auto-activate Subscribe mode when it initialises.
 */

(function () {
  'use strict';

  // ── SellingPlanSelector class ──────────────────────────────────────────────

  class SellingPlanSelector {
    constructor(el) {
      this.root       = el;
      this.productId  = el.dataset.productId;
      this.hiddenInput = el.querySelector('.mg-sps__input');
      this.details    = el.querySelector('.mg-sps__details');
      this.select     = el.querySelector('.mg-sps__select');
      this.buttons    = el.querySelectorAll('.mg-sps__opt');

      // Toggle buttons
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => this.setMode(btn.dataset.spsType));
      });

      // Frequency selector change
      if (this.select) {
        this.select.addEventListener('change', () => this.updateHiddenInput());
      }

      // Auto-activate subscribe mode if a Subscribe card button was clicked
      if (window._mgSubscribeIntent && window._mgSubscribeIntent === this.productId) {
        window._mgSubscribeIntent = null;
        // Small defer so the modal has finished opening
        requestAnimationFrame(() => this.setMode('subscribe'));
      }
    }

    setMode(mode) {
      this.buttons.forEach(btn => {
        const active = btn.dataset.spsType === mode;
        btn.classList.toggle('mg-sps__opt--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const isSubscribe = mode === 'subscribe';
      this.details.hidden      = !isSubscribe;
      this.details.setAttribute('aria-hidden', isSubscribe ? 'false' : 'true');
      this.hiddenInput.value   = isSubscribe ? (this.select ? this.select.value : '') : '';
    }

    updateHiddenInput() {
      if (this.select) this.hiddenInput.value = this.select.value;
    }
  }

  // ── Init helpers ──────────────────────────────────────────────────────────

  function initSelectors(scope) {
    (scope || document).querySelectorAll('.mg-sps').forEach(el => {
      if (el._mgSpsInit) return;
      el._mgSpsInit = true;
      new SellingPlanSelector(el);
    });
  }

  // ── Subscribe intent — set by the card-level Subscribe button ─────────────
  //
  // The card button carries data-subscribe-intent="{{ card_product.id }}".
  // We capture it on mousedown (before the modal starts opening) so it's
  // ready when the modal's AJAX content finishes loading.

  document.addEventListener('mousedown', function (e) {
    const btn = e.target.closest('[data-subscribe-intent]');
    if (btn) window._mgSubscribeIntent = btn.dataset.subscribeIntent;
  });

  // Touchstart for mobile
  document.addEventListener('touchstart', function (e) {
    const btn = e.target.closest('[data-subscribe-intent]');
    if (btn) window._mgSubscribeIntent = btn.dataset.subscribeIntent;
  }, { passive: true });

  // ── Quick Add modal observer ───────────────────────────────────────────────
  //
  // Modal content is injected into .quick-add-modal__content-info via AJAX.
  // Watch every such container so we can init selectors once content arrives.

  function observeQuickAddModals() {
    document.querySelectorAll('.quick-add-modal__content-info').forEach(container => {
      if (container._mgObserved) return;
      container._mgObserved = true;

      new MutationObserver(function () {
        initSelectors(container);
      }).observe(container, { childList: true, subtree: true });
    });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    initSelectors();
    observeQuickAddModals();
  }

  // Re-init after Shopify section re-render (e.g. currency change)
  document.addEventListener('shopify:section:load', function () {
    initSelectors();
    observeQuickAddModals();
  });

})();